export default __webpack_public_path__ + "static/media/noImage.520074c6.svg";